import * as fromActions from './user-licenses.actions';

import { License } from '@account-users/account/models/License';
import { LicensePermission } from '@account-users/account/models/LicensePermissionList';

export const USER_LICENSES_FEATURE_KEY = 'user-licenses';

export interface UserLicensesState {
  licenses: License[];
  permissions: LicensePermission[];
  isLoadingPermissions: boolean;
}

export const initialState: UserLicensesState = {
  permissions: [],
  licenses: [],
  isLoadingPermissions: false,
};

export function userLicensesreducer(
  state: UserLicensesState = initialState,
  action: fromActions.LicensesActions,
): UserLicensesState {
  switch (action.type) {
    case fromActions.UserLicensesActionTypes.LoadAllLicensesSuccess: {
      const licencesAndPermissions = action.payload;
      return {
        ...state,
        licenses: licencesAndPermissions.licenses,
        permissions: licencesAndPermissions.permissions,
        isLoadingPermissions: false,
      };
    }
    case fromActions.UserLicensesActionTypes.LoadAllLicenses: {
      return {
        ...state,
        isLoadingPermissions: true,
      };
    }
    case fromActions.UserLicensesActionTypes.LoadAllLicensesFailed: {
      return {
        ...state,
        isLoadingPermissions: false,
      };
    }
    default:
      return state;
  }
}
